import MuiMenuItem from "@mui/material/MenuItem";

export default function MenuItem(props) {
  return <MuiMenuItem {...props} />;
}
